(() => {
  if (window.TripleCCardVault) { window.TripleCCardVault(); return; }
  const element = (tag, text, className) => {
    const node = document.createElement(tag);
    if (text) node.textContent = text;
    if (className) node.className = className;
    return node;
  };
  function searchPanel(form, titleField, target) {
    const panel = element('section', '', 'tc-vault-search');
    const id = 'vault-search-' + target;
    const label = element('label', target === 'collection' ? 'Find your collectible' : 'Find your next collectible');
    label.htmlFor = id;
    const input = element('input');
    input.type = 'search'; input.id = id; input.placeholder = 'Name, set or card number'; input.maxLength = 200;
    const help = element('p', 'Choose a matching catalog result to fill in the details. You can also enter a title yourself.', 'tc-vault-help');
    const status = element('p', '', 'tc-vault-help'); status.setAttribute('role', 'status');
    const results = element('div', '', 'tc-vault-results');
    const selected = element('p', '', 'tc-vault-selected'); selected.setAttribute('role', 'status');
    const selectedImage = element('img', '', 'tc-vault-file-preview'); selectedImage.hidden = true; selectedImage.alt = 'Selected catalog image';
    panel.append(label, input, help, status, results, selected, selectedImage);
    form.prepend(panel);
    let timer, controller, revision = 0, filling = false;
    function selection(item) {
      for (const [name, value] of Object.entries({ catalogId: item?.catalogId || '', catalogProductId: item?.marketProductId || '', catalogTitle: item?.title || '', catalogVariant:item?.edition||'', catalogLanguage:item?.language||'',catalogCondition:[item?.grader,item?.grade,item?.condition].filter(Boolean).join(' ') })) {
        let field = form.querySelector('[name="' + name + '"]');
        if (!field) { field = element('input'); field.type = 'hidden'; field.name = name; form.append(field); }
        field.value = value;
      }
      selectedImage.hidden = true; selectedImage.removeAttribute('src');
      try { const url = new URL(item?.imageUrl); if(url.protocol === 'https:' && !url.username && !url.password && target !== 'collection') {selectedImage.src=url.href;selectedImage.hidden=false;} } catch {}
      form.dispatchEvent(new CustomEvent('triplec:catalog-selection', { detail: item?.imageUrl || '' }));
    }
    titleField.addEventListener('input', () => { if (!filling) { selection(null); selected.textContent = ''; } });
    const cancel = () => { revision++; clearTimeout(timer); controller?.abort(); results.replaceChildren(); status.textContent = ''; };
    input.addEventListener('input', () => {
      cancel(); selection(null); selected.textContent = '';
      const query = input.value.trim();
      if (query.length < 2) return;
      const current = revision;
      timer = setTimeout(async () => {
        const currentController = new AbortController(); controller = currentController;
        const deadline = setTimeout(() => currentController.abort(), 18000);
        status.textContent = 'Searching the Market catalog…';
        try {
          const response = await fetch('/apps/triple-c/market-intelligence?q=' + encodeURIComponent(query), { credentials: 'same-origin', cache: 'no-store', signal: currentController.signal });
          if (!response.ok) throw new Error('Search unavailable');
          const data = await response.json();
          if (current !== revision || !input.isConnected) return;
          const items = Array.isArray(data.items) ? data.items.filter(item => item && typeof item.title === 'string').slice(0, 8) : [];
          status.textContent = items.length ? 'Check the set and number, then choose your match.' : 'No matches found. Enter a title below to add it yourself.';
          for (const item of items) {
            const button = element('button', '', 'tc-vault-result'); button.type = 'button';
            if (item.imageUrl) {
              try {
                const url = new URL(item.imageUrl, location.origin);
                if (url.protocol === 'https:' || url.origin === location.origin) {
                  const image = element('img'); image.src = url.href; image.alt = ''; image.loading = 'lazy'; image.referrerPolicy = 'no-referrer';
                  image.addEventListener('error', () => image.remove(), { once: true }); button.append(image);
                }
              } catch {}
            }
            const copy = element('span', item.title);
            copy.append(element('small', [item.setName, item.cardNumber, item.category].filter(Boolean).join(' · ')));
            button.append(copy);
            button.addEventListener('click', () => {
              const details = [item.setName, item.cardNumber].filter(value => value && !item.title.toLowerCase().includes(String(value).toLowerCase()));
              titleField.value = [item.title, ...details].join(' · ').slice(0, 200);
              const category = form.querySelector('[name="category"]');
              if (category) category.value = item.gameSport || item.franchise || item.category || '';
              const condition = form.querySelector('[name="condition"]');
              if (condition && !condition.value) condition.value = [item.grader, item.grade, item.condition].filter(Boolean).join(' ').slice(0, 120);
              const queryField = form.querySelector('[name="wantQuery"]');
              if (queryField && !queryField.value) queryField.value = [item.setName, item.cardNumber, item.language].filter(Boolean).join(' · ').slice(0, 500);
              selection(item); filling = true;
              cancel(); selected.textContent = 'Selected: ' + titleField.value + '. Check the details before saving.';
              titleField.dispatchEvent(new Event('input', { bubbles: true })); titleField.focus(); filling = false;
            });
            results.append(button);
          }
        } catch (error) {
          if (current === revision) status.textContent = 'Catalog search is unavailable right now. You can still enter a title and save your collectible.';
        } finally { clearTimeout(deadline); }
      }, 300);
    });
    input.addEventListener('keydown', event => { if (event.key === 'Enter') { event.preventDefault(); } if (event.key === 'Escape') cancel(); });
  }
  function init() {
    document.querySelectorAll('input[type="file"][accept*="image"]').forEach(input => input.removeAttribute('capture'));
    const library = document.getElementById('collection-library');
    if (!library || library.dataset.vaultReady) return;
    library.dataset.vaultReady = '1';
    const hero = document.querySelector('.tc-collection-hero h1'); if (hero) hero.textContent = 'Your Card Vault.';
    document.querySelectorAll('.tc-collection-art').forEach(node => node.remove());
    const panel = document.getElementById('collection-add');
    const add = panel?.querySelector('form');
    if (add) {
      const disclosure = element('details', '', 'tc-vault-add');
      const summary = element('summary', '＋ Add a collectible');
      panel.before(disclosure); disclosure.append(summary, panel);
      const title = add.querySelector('[name="title"]');
      if (title) searchPanel(add, title, 'collection');
      const grid = add.querySelector('.tc-collection-form-grid');
      if (grid) {
        const optional = element('details', '', 'tc-vault-optional');
        const optionalGrid = element('div', '', 'tc-collection-form-grid');
        optional.append(element('summary', 'Optional details: condition, value, notes and showcase'), optionalGrid);
        for (const field of [...grid.children]) {
          if (!field.querySelector('[name="title"],[name="imageFile"],[name="visibility"]')) optionalGrid.append(field);
        }
        grid.append(optional);
      }
      const photo = add.querySelector('[name="imageFile"]');
      if (photo) {
        photo.removeAttribute('capture');
        const note = photo.parentElement.querySelector('.tc-help'); if (note) note.textContent = 'Catalog image is used automatically when available. Upload your own photo to replace it. Optional.';
        const preview = element('img', '', 'tc-vault-file-preview'); preview.alt = 'Your selected collectible photo'; preview.hidden = true; photo.after(preview);
        let previous, catalogImage = '';
        const updatePhoto = () => {
          if (previous) { URL.revokeObjectURL(previous); previous = null; }
          const file = photo.files?.[0];
          if (file?.type.startsWith('image/')) { previous = URL.createObjectURL(file); preview.src = previous; preview.hidden = false; preview.alt = 'Your selected collectible photo'; }
          else { preview.hidden = !catalogImage; if (catalogImage) preview.src = catalogImage; else preview.removeAttribute('src'); preview.alt = 'Selected catalog image'; }
        };
        add.addEventListener('triplec:catalog-selection', event => {
          catalogImage = '';
          try { const url = new URL(event.detail); if (url.protocol === 'https:' && !url.username && !url.password) catalogImage = url.href; } catch {}
          updatePhoto();
        });
        preview.addEventListener('error', () => { preview.hidden = true; });
        photo.addEventListener('change', updatePhoto);
      }
    }
    const wishlist = document.getElementById('collection-wishlist');
    const want = wishlist?.querySelector('input[name="intent"][value="want_add"]')?.form;
    if (want) {
      const details = element('details', '', 'tc-vault-add'); wishlist.before(details); details.append(element('summary', '＋ Add to wishlist'), wishlist);
      const title = want.querySelector('[name="wantTitle"]'); if (title) searchPanel(want, title, 'wishlist');
    }
    for (const form of document.querySelectorAll('.tc-want-image-picker form')) {
      const title = form.querySelector('[name="wantTitle"]');
      if (title) searchPanel(form, title, 'wishlist-' + form.querySelector('[name="id"]').value);
    }
    const pending = [], started = new WeakSet(); let working = 0;
    const norm = value => String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
    const loadImage = async image => {
      try {
        const response = await fetch('/apps/triple-c/market-intelligence?q=' + encodeURIComponent(image.dataset.wantTitle), {credentials:'same-origin',cache:'no-store'});
        if(!response.ok)return;
        const data=await response.json();
        const matches=(data.items || []).filter(item => {
          const details=[item.setName,item.cardNumber].filter(value=>value&&!item.title.toLowerCase().includes(String(value).toLowerCase()));
          return item.imageUrl && (item.catalogId || item.marketProductId) && [item.title,[item.title,...details].join(' · ')].some(title=>norm(title)===norm(image.dataset.wantTitle));
        });
        if(matches.length!==1 || !image.isConnected)return;
        const item=matches[0],form=new FormData();
        for(const [key,value] of Object.entries({intent:'want_image',id:image.dataset.wantId,catalogId:item.catalogId || '',catalogProductId:item.marketProductId || '',catalogTitle:item.title}))form.set(key,value);
        const saved=await fetch('/apps/triple-c/collection',{method:'POST',body:form,credentials:'same-origin',headers:{Accept:'application/json'}});
        if(!saved.ok || !saved.headers.get('content-type')?.includes('application/json'))return;
        const result=await saved.json();const url=new URL(result.imageUrl);
        if(result.ok===true&&result.saved===true&&url.protocol==='https:'&&!url.username&&!url.password){image.src=url.href;image.hidden=false;}
      } catch {}
    };
    const drain = () => {while(working<2&&pending.length){working++;loadImage(pending.shift()).finally(()=>{working--;drain();});}};
    const queue = image => {if(started.has(image))return;started.add(image);pending.push(image);drain();};
    const missing=[...document.querySelectorAll('[data-wishlist-image]:not([src])')];
    if(typeof IntersectionObserver==='function'){
      const cards=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){cards.unobserve(entry.target);queue(entry.target.querySelector('[data-wishlist-image]'));}}),{rootMargin:'200px'});
      missing.forEach(image=>{const card=image.closest('.tc-want-card');if(card)cards.observe(card);});
    }else missing.slice(0,8).forEach(queue);
    const grid = library.querySelector('.tc-grid');
    if (grid) {
      const toolbar = element('div', '', 'tc-vault-toolbar');
      const filter = element('input'); filter.type = 'search'; filter.placeholder = 'Search your collection'; filter.setAttribute('aria-label', 'Search your collection');
      const count = element('span', '', 'tc-vault-help'); count.setAttribute('role', 'status');
      const privacy = element('select'); privacy.setAttribute('aria-label', 'Filter collection visibility');
      for (const [value, text] of [['all', 'All pieces'], ['private', 'Private'], ['public', 'Public']]) { const option = element('option', text); option.value = value; privacy.append(option); }
      const hasVisibility = [...grid.querySelectorAll('.tc-chip')].some(chip => ['Private', 'Public'].includes(chip.textContent.trim()));
      toolbar.append(filter); if (hasVisibility) toolbar.append(privacy); toolbar.append(count); grid.before(toolbar);
      const update = () => {
        let shown = 0; const cards = [...grid.querySelectorAll('.tc-item')];
        for (const card of cards) {
          const text = card.textContent.toLowerCase();
          const publicItem = [...card.querySelectorAll('.tc-chip')].some(chip => chip.textContent.trim() === 'Public');
          card.hidden = !text.includes(filter.value.trim().toLowerCase()) || (privacy.value !== 'all' && publicItem !== (privacy.value === 'public'));
          if (!card.hidden) shown++;
        }
        count.textContent = shown + ' of ' + cards.length + ' pieces';
      };
      filter.addEventListener('input', update); privacy.addEventListener('change', update); update();
    }
    document.querySelectorAll('.tc-showcase .tc-item,.tc-collection-library .tc-item').forEach(card => {
      const forms = [...card.children].filter(child => child.tagName === 'FORM');
      if (!forms.length) return;
      const manage = element('details', '', 'tc-vault-manage'); manage.append(element('summary', 'Manage piece')); forms.forEach(form => manage.append(form)); card.append(manage);
    });
    document.querySelectorAll('.tc-collection-form-panel input,.tc-collection-form-panel select,.tc-collection-form-panel textarea').forEach((input, index) => {
      if (input.type === 'hidden' || input.type === 'checkbox') return;
      const label = input.parentElement.querySelector('label');
      if (label && !label.htmlFor) { input.id ||= 'vault-field-' + index; label.htmlFor = input.id; }
    });
  }
  window.TripleCCardVault = init;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
  document.addEventListener('triplec:page-ready', init);
})();
